module.exports = __webpack_public_path__ + "07.png?5dca2bf8fa031374e8d31b532557012a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/07.png
// module id = 121
// module chunks = 3